/**
 * @author: lv.chen
 * @date: 2025/7/15
 * @desc: MetricTips1指标气泡提示内容
 */
import React from 'react';
import classnames from 'classnames';
import { DATASOURCE_NAME, DataSourceBubbleInfo } from '@intelligence/components/DataSourceComponents';
import { getDataSourceIcon } from '@intelligence/utils/getDataSourceImg';
import { getMetricName } from '@intelligence/v3/components/TableComponents/RatioMetricSortBy/utils';
import { LANGUAGE_EN } from '@home/_config/config';

interface IMetricTips1Props extends IBaseProps {
  /**
   * 数据源
   */
  dataSource: string;
  /**
   * 指标
   */
  metric: string;
  /**
   * 内容
   */
  description: string | React.ReactElement;
}

const MetricTips1: React.FC<IMetricTips1Props> = (props) => {
  const { style, className, locale = LANGUAGE_EN, entityType, dataSource, metric, description } = props;

  return (
    <div style={style} className={classnames('dbi-metric-tips-content dbi-metric-tips-content1', className)}>
      <div className="dbi-metric-tips-content__desc">{description}</div>
      <div className="dbi-metric-tips-content__footer">
        <DataSourceBubbleInfo
          entityType={entityType}
          dataSource={dataSource}
          metricKey={metric}
          dataOfDom={getMetricName(locale as string, dataSource, metric)}
          comesFormDom={
            <div className="dbi-metric-tips-content1__comes-from-dom-wrapper">
              <img
                className="dbi-metric-tips-content1__comes-from-dom-icon"
                src={getDataSourceIcon(dataSource)}
                alt=""
              />
              {DATASOURCE_NAME[dataSource]}
            </div>
          }
        />
      </div>
    </div>
  );
};

export default MetricTips1;
